<template>
  <header class="main-menu">
    <div class="container">
      <section class="main-menu__logo">
        <div class="logo__container">
          <div class="logo__image">
            <a href="/" class="logo">
              <img src="../assets/sequire.svg" alt="Sequire Logo">
            </a>
          </div>
          <p>SMS Campaigns</p>
        </div>
        <button class="menu-toggle" @click="toggleMenu">
          <span v-if="!isMenuOpen">&#9776;</span>
          <span v-else>&times;</span>
        </button>
        <div class="overlay" v-if="isMenuOpen" @click="toggleMenu"></div>
        <div class="main-menu__links" v-bind:class="{ open: isMenuOpen }">
            <a href="#how-it-works" @click.prevent="handleMenuItemClick">
              How it works
            </a>
            <a href="#plans" @click.prevent="handleMenuItemClick">
              Plans
            </a>
            <a href="#contact" @click.prevent="handleMenuItemClick">
              Contact Us
            </a>
        </div>
      </section>
    </div>
  </header>
</template>

<script>
export default {
  name: 'main menu',
  data() {
    return {
      isMenuOpen: false
    };
  },
  mounted() {
    this.setupMenuLinks();
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    },
    handleMenuItemClick(event) {
      this.closeMenu();
      const targetId = event.target.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth' });
      }
    },
    setupMenuLinks() {
      const menuLinks = document.querySelectorAll('.main-menu a[href^="#"]');
      const HEADER_OFFSET = 65;

      menuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();

          const targetId = link.getAttribute('href');
          const targetElement = document.querySelector(targetId);

          if (targetElement) {
            const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
            window.scrollTo({ top: targetPosition, behavior: 'smooth' });

            if (this.isMobileMenuVisible) {
              this.closeMobileMenu();
            }
          }
        });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
  @import '@/styles/components/menu.scss';
</style>
